import { createFileRoute } from '@tanstack/react-router';
import { BoardConfigPage } from '@/features/tasks/admin/BoardConfigPage';

/**
 * Configurazione della bacheca — la faccia scrivibile di `kanban-board-configs/resolved`.
 *
 * Sta accanto ai **Flussi di lavorazione**, e non per comodità di menu: le colonne della bacheca
 * le dichiara il flusso, i limiti per colonna li dichiara questa pagina. Chi cerca «perché la
 * bacheca è fatta così» passa da una delle due, e da ciascuna si arriva all'altra.
 */
export const Route = createFileRoute('/_app/admin/board-config')({ component: BoardConfigPage });
